import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { versionsActions } from 'store';
import { Loader, SelectTypeAutocomplete } from 'components';
import { FindLoad } from 'utils';
import { ACTION_TYPE, platformColors, sectionConfig } from './constants';

export const ReleaseNotesPage = () => {
    const dispatch = useDispatch();
    const publishedVersions = useSelector((state) => state.versions.publishedVersions);
    const [filter, setFilter] = useState('');
    const loader = FindLoad(ACTION_TYPE)

    useEffect(() => {
        dispatch(versionsActions.getPublishedVersions());
        localStorage.setItem('last_seen_version_id', publishedVersions?.[0]?._id || '');
    }, []);

    useEffect(() => {
        if (publishedVersions?.length) {
            localStorage.setItem('last_seen_version_id', publishedVersions[0]._id);
        }
    }, [publishedVersions]);

    const lastSeenId = useMemo(() => {
        return localStorage.getItem('last_seen_version_id') || '';
    }, []);

    const uniqueVersions = useMemo(() => {
        return [...new Set(publishedVersions?.map((v) => v.version_number))];
    }, [publishedVersions]);

    const filteredVersions = useMemo(() => {
        if (!filter || filter === 'all') return publishedVersions;
        return publishedVersions?.filter((v) => v.version_number === filter);
    }, [publishedVersions, filter]);

    const isNew = (version) => {
        if (!lastSeenId) return true;
        return version._id > lastSeenId;
    };

    if(loader?.length){
        return <Loader/>
    }

    return (
        <div className="whats-new-container">
            <div className="whats-new-header">
                <h1 className="whats-new-title">What's New? ⭐</h1>

                <div style={{ width: '200px' }}>
                    <SelectTypeAutocomplete
                        placeholder={'All Versions'}
                        name={'version'}
                        handleSelect={(ev) => setFilter(ev?.target?.value)}
                        defaultValue={filter}
                        list={
                            uniqueVersions?.length ? [{
                                id: 'all',
                                name: 'All Versions'
                            }, ...uniqueVersions?.map((i) => ({ name: i, id: i }))] : [{
                                id: 'all',
                                name: 'All Versions'
                            }]
                        }
                        renderValue={(i) => i?.name}
                        uiType={'tableFilter'}
                        noError={true}
                    />
                </div>
            </div>

            <div className="whats-new-body-container">
                {!filteredVersions?.length ? (
                    <div className="whats-new-empty-state">No updates yet</div>
                ) : (
                    filteredVersions.map((version) => (
                        <div key={version._id} className="whats-new-card">
                            <div className="whats-new-card-header">
                                <div className="whats-new-card-title-row">
                                    <p className="whats-new-card-title">{version.title}</p>
                                    {isNew(version) && <span className="whats-new-badge">NEW</span>}
                                </div>
                                <div className="whats-new-card-date">
                                    {version.release_date
                                        ? new Date(version.release_date).toLocaleDateString('en-US', {
                                            year: 'numeric',
                                            month: 'short',
                                            day: 'numeric',
                                        })
                                        : ''}
                                </div>
                            </div>

                            {version.sections?.map((section, idx) => {
                                const config = sectionConfig[section.type] || { label: section.type };
                                const { label } = config;
                                return (
                                    <div key={idx} className="whats-new-section-row">
                                        <div className="whats-new-section-label-box">
                                        <span className="whats-new-section-label">
                                            {label}
                                        </span>
                                        </div>
                                        <ul className="whats-new-bullet-list">
                                            {section.items?.map((item, iIdx) => (
                                                <li key={iIdx} className="whats-new-bullet-item">
                                                    {item}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                );
                            })}

                            {(version.platforms?.length > 0 || version.learn_more_url) && (
                                <div className="whats-new-card-footer">
                                    <div className="whats-new-platforms-row">
                                        {version.platforms?.length > 0 && (
                                            <div>
                                                <p className="whats-new-platforms-label">Platforms</p>
                                                <div className='flex-align-center' style={{ gap: 4 }}>
                                                    {version.platforms.map((p) => {
                                                        const color = platformColors[p] || platformColors.Web;
                                                        return (
                                                            <div
                                                                key={p}
                                                                className="whats-new-platform-chip"
                                                                style={{
                                                                    backgroundColor: color.bg,
                                                                    color: color.color,
                                                                }}
                                                            >
                                                                {p}
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            </div>
                                        )}
                                    </div>

                                    {/*{version.learn_more_url && (*/}
                                    {/*    <div>*/}
                                    {/*        <p className="whats-new-platforms-label">How to use this feature</p>*/}
                                    {/*        <div>*/}
                                    {/*        <a*/}
                                    {/*            href={version.learn_more_url}*/}
                                    {/*            target="_blank"*/}
                                    {/*            rel="noopener noreferrer"*/}
                                    {/*            className="whats-new-learn-more-link"*/}
                                    {/*        >*/}
                                    {/*            Learn How &rarr;*/}
                                    {/*        </a>*/}
                                    {/*        </div>*/}
                                    {/*    </div>*/}
                                    {/*)}*/}
                                </div>
                            )}
                        </div>
                    ))
                )}
            </div>
        </div>
    );
};
